import {
  GOOGLE_LOCATION_START,
  GOOGLE_LOCATION_SUCCESS,
  GOOGLE_LOCATION_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  googleLocationData: null,
};

export default function googleReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case GOOGLE_LOCATION_START:
      return {
        ...state,
        loading: true,
        googleLocationData: null,
      };
    case GOOGLE_LOCATION_SUCCESS:
      return {
        ...state,
        googleLocationData: action.payload,
        loading: false,
      };
    case GOOGLE_LOCATION_ERROR:
      return {
        ...state,
        googleLocationData: null,
        loading: false,
      };
    default:
      return state;
  }
}
